import React, { useState } from 'react';

import { Link } from '../Link';
import { Svg } from '../Svg';

export function MobileMenuItem({ item }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-b-[#DDE2E71A]">
      <button
        aria-label={
          isOpen ? `Close ${item.title} menu` : `Open ${item.title} menu`
        }
        className="flex h-14 w-full items-center justify-between py-4"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <h3 className="text-base font-normal">{item.title}</h3>

        <Svg
          className={`w-4 text-white ${isOpen ? 'rotate-180' : ''}`}
          src="/svgs/chevron-down.svg#chevron-down"
          title="Chevron"
          viewBox="0 0 24 24"
        />
      </button>

      <ul
        className={`flex-col items-start gap-2 pb-9 ${
          isOpen ? 'flex' : 'hidden'
        }`}
      >
        {item.links?.map(({ link }, linkIndex) => {
          return (
            <li key={linkIndex}>
              <Link
                aria-label={link?.text}
                className="hover-text-underline mb-2 block text-sm font-light text-[#A6A8AE]"
                href={link?.url}
                newTab={link?.newTab}
              >
                {link?.text}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

MobileMenuItem.displayName = 'MobileMenuItem';
